import axios from "axios";
import Config from "src/config";

const v2_actionDeletarCanal = (canalId) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/canal/${canalId}/deletar`
    });
};

export default v2_actionDeletarCanal;
